import checkout from "./form9";

const {
  formField9: {
    endow,
    departmentLevel,
    subordinateToTheDepartment,
    city,
    district,
    commune,
    endowTNDN,
    endowKHCN,
    addressEndow,
    confirmEndow,
    dateConfirmEndow
  },
} = checkout;

const initialValues9 = {
  [endow.name]: "",
  [departmentLevel.name]: "",
  [subordinateToTheDepartment.name]: "",
  [city.name]: "",
  [district.name]: "",
  [commune.name]: "",

  [endowTNDN.name]: false,
  [endowKHCN.name]: false,
  [subordinateToTheDepartment.name]: "",
  [addressEndow.name]: "",
  [confirmEndow.name]: "",
  [dateConfirmEndow.name]: "",
};

export default initialValues9;
